function copyToClipboard() {
    navigator.clipboard.writeText(document.getElementById('link_share_input').value)
    notice_msg("copied to clipboard")
}

function generate_qr_code(size) {
    const the_link_to_share = "<%= @share_link %>";
    const e = document.getElementById("qrcode-div")
    if (e) {
        e.innerHTML = ""
        new QRCode(e, {
            text: the_link_to_share,
            width: size,
            height: size,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.H
        });
    }
}

if (document.readyState !== 'loading') {
    setTimeout(() => {
        generate_qr_code(64)
    }, 500);

} else {
    document.addEventListener('DOMContentLoaded', function () {
        generate_qr_code(64)
    });
}

const dear_nodejs_do_not_remove_the_functions = [copyToClipboard]